import routes from "@/constants/routes";
import { SubLayout } from "@/containers/layout/LandingLayout";
import Link from "next/link";

const KnowYourBudget = (): JSX.Element => {
  return (
    <SubLayout allowOverflow>
      <section className="relative z-30 flex flex-col items-center justify-center w-full mx-auto text-white mt-9 md:mt-5 md:-top-5 xl:-top-6 py-9 px-7 md:h-40 xl:h-60 rounded-2xl p-14 bg-landing-denim">
        <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[360px] md:max-w-fit">
          Know your budget?
        </h2>

        <div className="flex flex-col items-center justify-around text-center md:mt-5 md:flex-row w-full">
          <p className="my-6 font-serif text-xl font-normal md:my-auto xl:text-2xl whitespace-nowrap">
            Calculate your budget
          </p>
          <Link href={routes.calculator}>
            <a className="block min-w-[8.5rem] w-full px-4 py-3 mt-4 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow cursor-pointer xl:mt-0 md:w-max bg-landing-orange hover:scale-105 ">
              Calculate
            </a>
          </Link>
        </div>
      </section>
    </SubLayout>
  );
};

export default KnowYourBudget;
